export const DECLINE_EMAIL_SUBJECT =
  'Aggiornamento in merito alla tua richiesta di valutazione risarcimento - LeadLegale';

export function leadCourtesyName(lead) {
  const nome = String(lead?.nome || '').trim();
  const cognome = String(lead?.cognome || '').trim();
  return [nome, cognome].filter(Boolean).join(' ').trim() || 'Cliente';
}

export function defaultDeclineBody(lead) {
  const nome = leadCourtesyName(lead);
  return (
    `Gentile ${nome},\n` +
    'La ringraziamo per aver utilizzato la nostra piattaforma e per aver condiviso i dettagli relativi alla Sua richiesta.\n' +
    "A seguito dell'esame preliminare condotto dal nostro studio convenzionato, siamo spiacenti di comunicarLe che, allo stato attuale degli elementi forniti e visti i criteri interni di sostenibilità probatoria, non ci è possibile procedere con la presa in carico della Sua posizione.\n" +
    'Ci scusiamo per non poterLa assistere in questa circostanza. Resta naturalmente ferma la Sua libertà di sottoporre la documentazione a un altro professionista per una diversa valutazione.\n' +
    'Cordiali saluti,\n' +
    'Ufficio Pratiche - Studio Convenzionato LeadLegale'
  );
}

export function canDeclineLead(lead, { isAssigned = false, isAdmin = false } = {}) {
  if (!lead) return false;
  const stato = String(lead.stato || '').toLowerCase();
  if (stato === 'declinato' || lead.declined_at) return false;
  if (!isAdmin && !isAssigned) return false;
  return true;
}
